import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import knowledgeApi from '@/lib/knowledge-api'

export interface PromptSettings {
  id: string | null
  system_prompt: string
  task_instructions: string
  model: string
  temperature: number
  is_system: boolean
  is_tenant_override: boolean
}

interface PromptSettingsResponse {
  success: boolean
  settings: PromptSettings
  output_format: string
}

export function useActionItemsPromptSettings() {
  return useQuery({
    queryKey: ['action-items-prompt-settings'],
    queryFn: async () => {
      const response = await knowledgeApi.get<PromptSettingsResponse>(
        '/knowledge/interactions/action-items/prompt-settings/'
      )
      return response.data
    },
  })
}

export function useUpdateActionItemsPromptSettings() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (settings: {
      system_prompt: string
      task_instructions: string
      model: string
      temperature: number
    }) => {
      const response = await knowledgeApi.put<PromptSettingsResponse>(
        '/knowledge/interactions/action-items/prompt-settings/update/',
        settings
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['action-items-prompt-settings'] })
    },
  })
}
